export default "__VITE_ASSET__DQbVcDR4__"